export enum ShipmentConsolStatus {
    CONSOL_CREATED = 1,
    PAYMENT_FAILED,
    PAID,
    IN_PROGRESS,
    CUSTOM_CLEARANCE_PROCESS,
    CUSTOMS_CLEARED,
    SHIPMENT_DELIVERED,
    CANCELED,
    DELIVERED,
    PENDING,
    NEW,
    DRAFT,
    COMPLETED,
    COLLECTED,
    IN_TRANSIT,
    PENDING_COLLECTION,
    PENDING_CUSTOMER_COLLECTION,
    DELIVERY_ATTEMPT_FAILED,
    DELIVERY_ADDRESS_CHANGED,
    DELIVERY_REFUSED,
    CUSTOM_DELAY,
    SHIPMENT_DELAYED,
    DELAYED_DUE_PAYMENT,
    INCORRECT_ADDRESS,
    SHIPMENT_REJECTED,
    SHIPMENT_RETURNED,
    SHIPMENT_LOST,
    SHIPMENT_ARRIVED_DESTINATION_PORT,
    CUSTOM_CLEARED,
    SHIPMENT_BACK_2_TRANSIT,
    NEW_ADDRESS_RECEIVED,
    DELIVERY_IN_PROCESS,
    SHIPMENT_CANCELED,
    DELAYED,
    PENDING_DELIVERY,

    // Aftership statuses
    // Pending
    PENDING_001 = 101,
    PENDING_002 = 102,
    PENDING_003 = 103,
    PENDING_004 = 104,
    PENDING_005 = 105,
    PENDING_006 = 106,

    // Info Received
    INFORECEIVED_001 = 111,

    // In Transit
    INTRANSIT_001 = 121,
    INTRANSIT_002 = 122,
    INTRANSIT_003 = 123,
    INTRANSIT_004 = 124,
    INTRANSIT_005 = 125,
    INTRANSIT_006 = 126,
    INTRANSIT_007 = 127,
    INTRANSIT_008 = 128,
    INTRANSIT_009 = 129,

    // Out for Delivery
    OUTFORDELIVERY_001 = 131,
    OUTFORDELIVERY_003 = 133,
    OUTFORDELIVERY_004 = 134,

    // Attempt Fail
    ATTEMPTFAIL_001 = 141,
    ATTEMPTFAIL_002 = 142,
    ATTEMPTFAIL_003 = 143,

    // Delivered
    DELIVERED_001 = 151,
    DELIVERED_002 = 152,
    DELIVERED_003 = 153,
    DELIVERED_004 = 154,

    // Available for Pickup
    AVAILABLEFORPICKUP_001 = 161,

    // Exception
    EXCEPTION_001 = 171,
    EXCEPTION_002 = 172,
    EXCEPTION_003 = 173,
    EXCEPTION_004 = 174,
    EXCEPTION_005 = 175,
    EXCEPTION_006 = 176,
    EXCEPTION_007 = 177,
    EXCEPTION_008 = 178,
    EXCEPTION_009 = 179,
    EXCEPTION_010 = 180,
    EXCEPTION_011 = 181,
    EXCEPTION_012 = 182,
    EXCEPTION_013 = 183,
    EXCEPTION_014 = 184,

    // Expired
    EXPIRED_001 = 191,

    // Amazon
    PENDING_AVAILABILITY = 201,
    UNSHIPPED = 202,
    PARTIALLY_SHIPPED = 203,
    SHIPPED = 204,
    CANCELLED = 205,
    UNFULFILLABLE = 206,
    // Dropped off
    DROPPED_OFF = 192,

    // VintedGo tracking statuses (193+)
    VINTEDGO_CREATED = 193,
    VINTEDGO_FIRST_LEG_SHIPMENT_CREATED = 194,
    VINTEDGO_CANCEL_DROP_OFF = 195,
    VINTEDGO_DROP_OFF_CANCELLED_BY_CS = 196,
    VINTEDGO_SORTING_CENTER = 197,
    VINTEDGO_SORTED = 198,
    VINTEDGO_LOADED_TO_TRUCK = 199,
    VINTEDGO_IN_TRANSFER_POINT = 200,
    VINTEDGO_ON_THE_ROAD = 201,
    VINTEDGO_PARTNER_OUT_FOR_DELIVERY = 202,
    VINTEDGO_PARTNER_TIME_SLOT_SELECTED = 203,
    VINTEDGO_LEFT_OUR_NETWORK = 204,
    VINTEDGO_RELABELLED = 205,
    VINTEDGO_PARCEL_COLLECTED_BY_SENDER = 206,
    VINTEDGO_EMPTY_LOCKER_FOUND = 207,
    VINTEDGO_DELIVERY = 208,
    VINTEDGO_RETURN = 209,
    VINTEDGO_OVERSIZED_RETURN = 210,
    VINTEDGO_REDIRECTED = 211,
    VINTEDGO_OVERSIZED_REDIRECTED = 212,
    VINTEDGO_DISPOSED = 213,
    VINTEDGO_NO_PARCEL = 214,
    VINTEDGO_EXTERNAL_REDIRECTED = 215,
    VINTEDGO_SMS_NOTIFICATION_SENT = 216,
    VINTEDGO_EMAIL_NOTIFICATION_SENT = 217,
    VINTEDGO_REMINDER_SMS_NOTIFICATION_SENT = 218,
    VINTEDGO_REMINDER_EMAIL_NOTIFICATION_SENT = 219,

    // Partner tracking statuses (220+)
    ORDER_CREATED = 220,
    PRE_ADVISED = 221,
    PICKED_UP = 222,
    READY_FOR_PICKUP = 223,
    OUT_FOR_DELIVERY = 224,
    EXCEPTION = 225,
    DELIVERY_FAILED = 226,
    TRACKING_UNAVAILABLE = 227,
    RETURNED = 228,
    ARRIVED_AT_TRANSIT_CENTER = 229,
    DEPARTED_TRANSIT_CENTER = 230,
    ARRIVED_AT_DELIVERY_STATION = 231,
    DEPARTED_DELIVERY_STATION = 232,
    RECEIVED_BY_COURIER = 233,
    DELIVERY_EXCEPTION = 234,
    RETURNED_TO_TRANSIT_CENTER = 235,
    RETURN_AWAITING_LOADING = 236,
    RETURN_RECEIVED = 237,
    CONFIRMED_LOST = 238,
    CONFIRMED_STOLEN = 239,
}
